import { render, staticRenderFns } from "./DkWizardLeadFormColorSelection.vue?vue&type=template&id=64b92934&"
import script from "./DkWizardLeadFormColorSelection.vue?vue&type=script&lang=js&"
export * from "./DkWizardLeadFormColorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports